
    import { Component, Vue } from 'vue-facing-decorator';
    import { Getter } from '@/plugins/vuex-decorators';
    
    const namespace = 'main';
    @Component({
        components: {
        },
    })
    export default class ModelLogo extends Vue {
        @Getter('getModel', { namespace }) getModel: any;
    }
